import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import doneSvg from "../../../assets/img/icons/done02.svg";
import Confetti from "react-confetti";
import axios from "axios";
import RejectModal from "../prdashboard/RejectModal";
import RejectModalSociety from "../prdashboard/RejectModalSociety";
import ArticleDetailsModal from "../prdashboard/ArticleDetailsModal";
import ReasonModal from "../prdashboard/ReasonModal";
import Dropdown from "react-bootstrap/Dropdown";
import notyet from "../../../assets/img/icons/notarticle.svg";
import { get15DaysAheadDate, getDateFormat, downLoadFile, getNameFromUrl } from "../../../utils";
import { Link, useNavigate } from "react-router-dom";
import jwt_decode from "jwt-decode";
import {
  acceptRejectArticle,
  getAppointRoleForPE,
  downloadWordArticle,
  reviewArticle,
  updateAppointRoleForPE,
} from "../../../store/apiCalls/dashboard";
import { toast } from "react-toastify";
import { notAcceptedArticleReason } from "../../../store/apiCalls/dashboard";
import ConfirmationalModal from "../prdashboard/ConfirmationModal";
import { SERVER_URL } from "../../../config";
import { useSelector, useDispatch } from "react-redux";
import {
  updatePayment,
  iniitatePayments,
} from "../../autherFlow/submitArticle/queries";
import { UploadMedia } from "../../../store/apiCalls/profileDetails";
import { publishFromAdminSideApi } from "../../../store/apiCalls/articles";
import { useRef } from "react";



// Conference papers in society journals don't follow the pre-publication peer review workflow
const isSocietyConferencePaper = (editor) => {
  const detail = editor?.article?.[0]?.submissionDetail;
  const journalType = detail?.journalType?._id || detail?.journalType;
  const articleType = detail?.articleType?._id || detail?.articleType;
  return (
    journalType === "6454a6390d88e62fa10503bf" &&
    articleType === "664aed76ada7b4f743b760a9"
  );
};

const PEListing = ({
  peData,
  peActiveTab,
  fetchPublishingEditor,
  totalNoOfRecords,
  hasMoreRecords,
  setUpdateRequestList,
  setPEActiveTab,
  getPEType,
}) => {
  // console.log(peData,'peData')
  const MAX_WORDS = 30;
  const societyJournalID = "6454a6390d88e62fa10503bf";
  const navigate = useNavigate();
  const { id } = jwt_decode(localStorage.usertoken);
  const [showArticleDetails, setShowArticleDetails] = useState(false);
  const [showAccept, setShowAccept] = useState(false);
  const [reasonInput, setReasonInput] = useState("");
  const [appointRoleResponse, setAppointRoleResponse] = useState("");
  const [roleStatusResponse, setRoleStatusResponse] = useState("");
  const [showBecomePE, setShowBecomePE] = useState(false);
  const [showAcceptRequest, setShowAcceptRequest] = useState(false);
  const [showRejectRequest, setShowRejectRequest] = useState(false);
  const [showRejectPublishingRole, setShowRejectPublishingRole] =
    useState(false);
  const [showReject, setShowReject] = useState(false);
  const [showSocietyReject, setShowSocietyReject] = useState(false);
  const [showAcceptConfirmation, setShowAcceptConfirmation] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [showNotAccepted, setShowNotAccepted] = useState(false);
  const [showReadMore, setShowReadMore] = useState([]);
  const [reasonHandle, setReasonHandle] = useState("");
  const [reasonComments, setReasonComments] = useState("");
  const [articleId, setArticleId] = useState("");
  const [rejectionArticleId, setRejectionArticleId] = useState("");
  const [articleData, setArticleData] = useState([]);
  // console.log(articleData,"articleDataarticleData")
  const [currentData, setCurrentData] = useState([]);
  const [userDetail, setUserDetail] = useState([]);

  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [paymentArticleId, setPaymentArticleId] = useState(null);
  const [selectedArticle, setSelectedArticle] = useState(null);
  const [isGatewayPaymentSuccessful, setIsGatewayPaymentSuccessful] = useState(false);
  const [showCongratsModal, setShowCongratsModal] = useState(false);
  const [upiScreenshotUrl, setUpiScreenshotUrl] = useState("");
  const [upiTransactionId, setUpiTransactionId] = useState("");
  const hiddenFileInput = useRef();

  const dispatch = useDispatch();
  const { user } = useSelector((state) => state?.LoginReducer || {});

  const sucessHandlerUpdatePayment = (data) => { };
  const { mutate: updatePaymentStatus } = updatePayment(sucessHandlerUpdatePayment);

  function updatePaymentData(response, access_key) {
    const headers = { Authorization: `Bearer ${localStorage?.usertoken}` };
    let initialPayment = false;
    let finalPayment = false;
    let totalPayment = false;
    if (response.status === "success") {
      if (response.udf2 === "intPay") initialPayment = true;
      else if (response.udf2 === "finalPay") finalPayment = true;
      else if (response.udf2 === "totalPay") totalPayment = true;
    }
    const payloads = {
      strike: true,
      currencyType: "INR",
      paymentMode: response.card_type,
      txnid: response.txnid,
      initialPayment: initialPayment,
      finalPayment: finalPayment,
      totalPayment: totalPayment,
      articleId: response.udf1,
      data: access_key,
      mode: response.mode,
      status: response.status,
      gst: ((18 / 100) * response.amount).toFixed(2),
      payableAmount: response.net_amount_debit,
      lastPrice: response.net_amount_debit,
      typeOfPayment: response.net_amount_debit,
    };
    const queryParams = { payload: payloads, headers };
    if (response.status === "success") {
      const selJournalName = selectedArticle?.article?.[0]?.submissionDetail?.journalName?.trim()?.toLowerCase();
      const isMWP = (selJournalName === "community learning and social transformation" ||
        selJournalName === "applied and basic obesity, diabetes and endocrinology" ||
        selJournalName === "applied and basic obesity, diabetes and endocrinology journal" ||
        selJournalName?.includes("applied and basic obesity, diabetes and endocrinology")) &&
        (selectedArticle?.article?.[0]?.submissionDetail?.journalType === "6454a6390d88e62fa10503bf");
      updatePaymentStatus(queryParams, {
        onSuccess: () => {
          if (isMWP) {
            const articleDocId = selectedArticle?.articleId || selectedArticle?.article?.[0]?._id || response.udf1;
            publishFromAdminSideApi(headers, {}, articleDocId)
              .then(() => {
                window.location.href = `/manage-payment/${articleDocId}`;
              })
              .catch((err) => {
                console.error("Error publishing article:", err);
                window.location.href = `/manage-payment/${articleDocId}`;
              });
            setShowPaymentModal(false);
          } else {
            handleAcceptRejectArticle(paymentArticleId, "published");
            setShowPaymentModal(false);
          }
        },
        onError: (err) => {
          console.error("Error updating payment status:", err);
          toast.error("Failed to update payment status on server.");
        }
      });
    } else {
      updatePaymentStatus(queryParams);
      toast.error("Payment failed. Please try again.");
    }
  }

  const sucessHandlerPayment = (info) => {
    if (info.status === 200) {
      dispatch({ type: "SET_LOADER", payload: true });
      const script = document.createElement("script");
      script.src = process.env.REACT_APP_PAYMENT_SCRIPT;
      script.id = "paymentScript";
      script.async = true;
      if (!document.getElementById("paymentScript"))
        document.body.appendChild(script);
      setTimeout(function () {
        dispatch({ type: "SET_LOADER", payload: false });
        var easebuzzCheckout = new window.EasebuzzCheckout(
          process.env.REACT_APP_PAYMENT_KEY,
          process.env.REACT_APP_PAYMENT_MODE
        );
        var options = {
          access_key: info.data.data, // access key received via Initiate Payment
          onResponse: (response) => {
            updatePaymentData(response, info.data.data);
          },
          theme: "#336d91", // color hex
        };
        easebuzzCheckout.initiatePayment(options);
      }, 1000);
    }
  };
  const { mutate: iniitatePayment } = iniitatePayments(sucessHandlerPayment);

  async function paymentInitiation(articleID) {
    // Society conference papers: INR 2999 inclusive of GST
    const amnt = isSocietyConferencePaper(selectedArticle)
      ? "2999.00"
      : (6499 * 1.18).toFixed(2).toString();
    const redairectTo = `${SERVER_URL}/dashboard`;
    const payloads = {
      key: process.env.REACT_APP_PAYMENT_KEY,
      amount: amnt,
      productinfo: "Article Publication Fee",
      firstname: user?.fullName || "User",
      phone: user?.phoneNumber || "0000000000",
      email: user?.email || "user@example.com",
      surl: `${redairectTo}`,
      furl: `${redairectTo}?type=failed`,
      salt: process.env.REACT_APP_PAYMENT_SALT,
      udf1: articleID,
      udf2: "totalPay",
      udf3: "",
      udf4: "",
      udf5: "",
      udf6: "",
      udf7: "",
      udf8: "",
      udf9: "",
      udf10: "",
      userId: id,
      articleId: articleID,
    };
    var formBody = [];
    for (var property in payloads) {
      var encodedKey = encodeURIComponent(property);
      var encodedValue = encodeURIComponent(payloads[property]);
      formBody.push(encodedKey + "=" + encodedValue);
    }
    formBody = formBody.join("&");
    const headers = { Authorization: `Bearer ${localStorage?.usertoken}` };
    const queryParams = { payload: formBody, headers };
    iniitatePayment(queryParams);
  }

  const handleUploadScreenshot = async (event) => {
    let file = event.target.files[0];
    if (file) {
      if (file.type?.split("/")[0] === "image" && file.size < 50000000) {
        dispatch({ type: "SET_LOADER", payload: true });
        const formData = new FormData();
        formData.append("file", file);
        try {
          const imgResp = await UploadMedia(formData);
          if (imgResp.status === 200 && imgResp.data.url) {
            setUpiScreenshotUrl(imgResp.data.url);
            toast.success("Screenshot uploaded successfully.");

            // Immediately update the payment status and store upiScreenshot in the DB
            const articleId = selectedArticle?.articleId || selectedArticle?.article?.[0]?._id;
            if (articleId) {
              const headers = { Authorization: `Bearer ${localStorage?.usertoken}` };
              const payloads = {
                articleId,
                finalPayment: true,
                paymentMode: "UPI",
                status: "success",
                upiScreenshot: imgResp.data.url,
              };
              const queryParams = { payload: payloads, headers };
              updatePaymentStatus(queryParams);
            }
          } else {
            toast.error("Screenshot upload failed.");
          }
        } catch (error) {
          toast.error("Screenshot upload failed.");
        } finally {
          dispatch({ type: "SET_LOADER", payload: false });
        }
      } else {
        toast.error("Please upload an image file smaller than 50MB.");
      }
    }
  };

  const copyUpiToClipboard = () => {
    navigator.clipboard.writeText("9810846333.eazypay@icici");
    toast.success("UPI ID copied to clipboard!");
  };

  const getType = new URLSearchParams(window.location.search).get("type") || "";
  const handleAcceptRejectArticle = async (_id, status, screenshotUrl = null, transactionId = null) => {
    const headers = { Authorization: `Bearer ${localStorage?.usertoken}` };
    const params = {
      id: _id,
      peStatus: status,
      peId: id,
    };
    if (screenshotUrl) {
      params.upiPaymentScreenshot = screenshotUrl;
    }
    if (transactionId) {
      params.upiTransactionId = transactionId;
    }
    const response = await acceptRejectArticle(headers, params);
    if (response?.status === 200) {
      setShowAcceptConfirmation(false);
      if (status === "published") {
        toast.success("Article published successfully");
        fetchPublishingEditor(peActiveTab);
      } else {
        setShowAccept(true);
        fetchPublishingEditor("draft");
      }
    } else {
      return toast.error("Please try again!!");
    }
  };

  const handleApprovedArchiveArticle = async (_id, status, archiveStatus) => {
    const headers = { Authorization: `Bearer ${localStorage?.usertoken}` };
    const params = {
      id: _id,
      peStatus: status,
      peId: id,
      previousUndoState: archiveStatus,
    };
    const response = await acceptRejectArticle(headers, params);
    if (response?.status === 200) {
      fetchPublishingEditor("approved");
    } else {
      return toast.error("Please try again!!");
    }
  };

  const handleRejectedArchiveArticle = async (_id, status, archiveStatus) => {
    const headers = { Authorization: `Bearer ${localStorage?.usertoken}` };
    const params = {
      id: _id,
      peStatus: status,
      peId: id,
      previousUndoState: archiveStatus,
    };
    const response = await acceptRejectArticle(headers, params);
    if (response?.status === 200) {
      fetchPublishingEditor("rejected");
    } else {
      return toast.error("Please try again!!");
    }
  };

  const handleNotAcceptedReason = async (articleId) => {
    const headers = { Authorization: `Bearer ${localStorage?.usertoken}` };
    const params = {
      userId: id,
      articleId,
      status: "pe",
    };
    const response = await notAcceptedArticleReason(headers, params);
    if (response?.status === 200) {
      setShowNotAccepted(true);
      setReasonHandle(response?.data?.data?.[0]?.reason);
      setReasonComments(response?.data?.data?.[0]?.additionalComment);
    } else {
      return toast.error("Please try again!!");
    }
  };

  const getReviewArticle = async (_id) => {
    const headers = { Authorization: `Bearer ${localStorage?.usertoken}` };
    const params = {
      articleId: _id,
    };
    const response = await reviewArticle(headers, params);
    if (response?.status === 200) {
      setArticleData(response?.data?.data);
      setCurrentData(response?.data?.currentStatus);
      setUserDetail(response?.data?.userDetail);
      setShowArticleDetails(true);
    } else {
      return toast.error("Please try again!!");
    }
  };

  const handleReadMore = (idx) => {
    let result = [...showReadMore];
    result[idx] = !result[idx];
    setShowReadMore(result);
  };

  const handleGetAppointRoleForPE = async () => {
    const headers = { Authorization: `Bearer ${localStorage?.usertoken}` };
    const params = {
      userId: id,
      page: 1,
      limit: 1,
    };
    const response = await getAppointRoleForPE(headers, params);
    if (response?.status === 200) {
      setAppointRoleResponse(response?.data?.data);
      setRoleStatusResponse(response?.data?.data?.[0]?.status);
    } else {
      return toast.error("Please try again!!");
    }
  };
  const handledownloadWordArticleFun = async (headers, params) => {
    return axios.get(
      `${SERVER_URL}/AakashGanga/downloadWordFileArticle`,
      {
        headers,
        params,
        responseType: "blob", // Ensure the response is in binary format (blob)
      },
    );
  };
  const handledownloadWordArticle = async (articleId) => {
    try {
      const headers = { Authorization: `Bearer ${localStorage?.usertoken}` };
      const params = {
        userId: id,
        articleId: articleId,
      };

      const response = await handledownloadWordArticleFun(headers, params);

      if (response.status === 200) {
        // Create a Blob from the response data
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        });

        // Create a temporary URL for the Blob
        const url = window.URL.createObjectURL(blob);

        // Create a hidden link element to trigger the download
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "article.docx"); // Set a filename for the downloaded file
        document.body.appendChild(link);

        // Trigger the download
        link.click();

        // Clean up: remove the link and revoke the object URL
        link.remove();
        window.URL.revokeObjectURL(url);
      } else {
        return toast.error("Please try again!!");
      }
    } catch (error) {
      console.error("Error downloading document:", error);
      return toast.error("An error occurred while downloading the document!");
    }
  };

  const downloadContract = (url) => {
    if (url) {
      let filename = getNameFromUrl(url);
      if (filename.includes("?")) {
        let finalFilename = filename?.split("?")[0];
        downLoadFile(url, `${finalFilename}`);
      } else {
        downLoadFile(url, `${filename}`);
      }
    }
  };

  const handleUpdateRoleForPE = async (status) => {
    const headers = { Authorization: `Bearer ${localStorage?.usertoken}` };
    if (status === "Accepted") {
      const params = {
        id: appointRoleResponse?.[0]?._id,
        status: status,
      };
      const response = await updateAppointRoleForPE(headers, params);
      if (response?.status === 200) {
        setShowBecomePE(false);
        setShowAcceptRequest(true);
        navigate("/dashboard/society-editor");
      } else {
        return toast.error("Please try again!!");
      }
    } else if (status === "Rejected") {
      const params = {
        id: appointRoleResponse?.[0]?._id,
        status: status,
        reason: reasonInput,
      };
      const response = await updateAppointRoleForPE(headers, params);
      if (response?.status === 200) {
        setShowRejectPublishingRole(false);
        navigate("/dashboard/society-editor");
      } else {
        return toast.error("Please try again!!");
      }
    }
  };

  const getUserDetails = (user) => {
    return [user?.name, user?.department, user?.city, user?.state]
      .filter(
        (item) =>
          item &&
          item.toString().trim() !== "" &&
          item.toString().trim().toLowerCase() !== "undefined",
      )
      .join(", ");
  };

  const getPeerReviewOutcome = (editor) => {
    const recommendation = editor?.prReview?.recommendation;

    if (recommendation) {
      return {
        label: recommendation,
        style: {
          color: "#1f8f57",
          fontWeight: "700",
          fontSize: "18px",
        },
      };
    }

    if (editor?.status === "approved") {
      return {
        label: "Accepted",
        style: {
          // backgroundColor: "#e8f7ee",
          color: "#1f8f57",
        },
      };
    }

    if (editor?.status === "rejected") {
      return {
        label: "Rejected",
        style: {
          // backgroundColor: "#fdecec",
          color: "#ff8300",
        },
      };
    }

    if (editor?.status === "sentForRevision") {
      return {
        label: "Sent for Second Review",
        style: {
          // backgroundColor: "#d7f0ff",
          color: "#336d91",
        },
      };
    }

    return null;
  };

  useEffect(() => {
    let myArray = new Array(peData?.length).fill(false);
    setShowReadMore(myArray);
  }, [peData]);

  useEffect(() => {
    handleGetAppointRoleForPE();
    if (getType === "publisheditor" && roleStatusResponse == "Pending") {
      setShowBecomePE(true);
    } else if (
      getType === "publisheditor" &&
      (roleStatusResponse == "Accepted" || roleStatusResponse == "Rejected")
    ) {
      setShowBecomePE(false);
    }
  }, [getType, roleStatusResponse]);

  const selJournalNameForPayment = selectedArticle?.article?.[0]?.submissionDetail?.journalName?.trim()?.toLowerCase();
  const isMWP = (selJournalNameForPayment === "community learning and social transformation" ||
    selJournalNameForPayment === "applied and basic obesity, diabetes and endocrinology" ||
    selJournalNameForPayment === "applied and basic obesity, diabetes and endocrinology journal" ||
    selJournalNameForPayment?.includes("applied and basic obesity, diabetes and endocrinology")) &&
    (selectedArticle?.article?.[0]?.submissionDetail?.journalType === "6454a6390d88e62fa10503bf");

  const isPaymentProofProvided = isMWP
    ? !!(upiScreenshotUrl || (upiTransactionId && upiTransactionId.trim() !== "") || isGatewayPaymentSuccessful)
    : true;

  return (
    <>
      <style>{`
        .payment-modal-header {
          padding-left: 80px !important;
          padding-right: 80px !important;
          text-align: center !important;
          font-family: "Montserrat", sans-serif !important;
        }
        .payment-modal-header .modal-title {
          margin-top: 50px !important;
          font-family: "Montserrat", sans-serif !important;
        }
        .payment-modal-body {
          padding-left: 80px !important;
          padding-right: 80px !important;
          text-align: left !important;
          font-size: 16px !important;
          color: #000000 !important;
          font-family: "Montserrat", sans-serif !important;
        }
        .payment-modal-body p,
        .payment-modal-body strong,
        .payment-modal-body h5,
        .payment-modal-body label,
        .payment-modal-body button,
        .payment-modal-body input,
        .payment-modal-body div,
        .payment-modal-body span {
          color: #000000 !important;
          font-family: "Montserrat", sans-serif !important;
        }
        .payment-modal-footer {
          padding-left: 80px !important;
          padding-right: 80px !important;
          justify-content: center !important;
          font-family: "Montserrat", sans-serif !important;
        }
         .payment-modal-footer button,
        .payment-modal-footer span {
          font-family: "Montserrat", sans-serif !important;
        }
        .view-invoice-btn {
          color: #167092 !important;
          background-color: #ffffff !important;
          border-bottom: 3px solid #167092 !important;
          transition: none !important;
        }
        .view-invoice-btn:hover,
        .view-invoice-btn:focus,
        .view-invoice-btn:active {
          color: red !important;
          background-color: #ffffff !important;
          border-bottom: 3px solid #167092 !important;
          box-shadow: none !important;
          outline: none !important;
        }
        .button-border-hover-red {
          transition: none !important;
        }
        .button-border-hover-red:hover,
        .button-border-hover-red:focus,
        .button-border-hover-red:active {
          color: red !important;
          background-color: transparent !important;
          border-color: #167092 !important;
          box-shadow: none !important;
          outline: none !important;
        }
        .payment-modal-body p.mandatory-blink-text {
          color: red !important;
          font-weight: normal !important;
          font-size: 13px !important;
          animation: blink-animation 1s steps(2, start) infinite !important;
        }
        @keyframes blink-animation {
          to {
            visibility: hidden;
          }
        }
        .footAction {
          white-space: nowrap !important;
          flex-wrap: nowrap !important;
        }
        .footAction .button,
        .footAction button,
        .footAction a {
          white-space: nowrap !important;
          flex-shrink: 0 !important;
        }
      `}</style>
      <div className="contentListBox">
        {peData && peData?.length > 0 ? (
          peData?.map((editor, index) => {
            const specialCharPattern = /[!@#$%^*(),.?;":{}|\u00a0]/g;
            const itemJournalName = editor?.article?.[0]?.submissionDetail?.journalName?.trim()?.toLowerCase();
            const itemIsMWP = itemJournalName === "community learning and social transformation" ||
              itemJournalName === "applied and basic obesity, diabetes and endocrinology" ||
              itemJournalName === "applied and basic obesity, diabetes and endocrinology journal" ||
              itemJournalName?.includes("applied and basic obesity, diabetes and endocrinology");
            const itemIsSelfPay = editor?.article?.[0]?.paymentBySociety?.apcPayBySociety === false;
            const showRedDot = itemIsMWP && itemIsSelfPay;

            const contentWithoutSpecialChars = () => {
              return editor?.article[0]?.abstract?.replace(
                specialCharPattern,
                "",
              );
            };

            return (
              <div>
                <div className="contentList">
                  {peActiveTab === "draft" && (
                    <div className="contentListHead">
                      <div className="timeList">
                        <span>
                          <strong>Received On:&nbsp;</strong>
                          {getDateFormat(editor?.createdAt)}
                        </span>
                        <span>
                          <strong>Due By:&nbsp;</strong>
                          {get15DaysAheadDate(editor?.updatedAt, 15)}
                        </span>
                      </div>
                      <span className="t-type mr-0">
                        {editor?.status === "New" ? (
                          "New Submission"
                        ) : editor?.status === "Revised Submission" ? (
                          <span className="text-transform-none" style={{ color: "#167092", fontWeight: 700 }}>
                            Revised Submission
                          </span>
                        ) : (
                          editor?.status
                        )}{" "}
                        <b className="red-text blink_me">*</b>
                      </span>
                    </div>
                  )}
                  {peActiveTab === "secondReview" && (
                    <div className="contentListHead">
                      <div className="timeList">
                        <span>
                          <strong>Received On:&nbsp;</strong>
                          {getDateFormat(editor?.createdAt)}
                        </span>
                        <span>
                          <strong>Due By:&nbsp;</strong>
                          {get15DaysAheadDate(editor?.updatedAt, 15)}
                        </span>
                      </div>
                      <span className="t-type mr-0 text-transform-none" style={{ color: "#167092", fontWeight: 700 }}>
                        Revised Submission{" "}
                        <b className="red-text blink_me">*</b>
                      </span>
                    </div>
                  )}
                  {peActiveTab === "accepted" && (
                    <div className="contentListHead">
                      <div className="timeList">
                        <span>
                          <strong>Accepted:&nbsp;</strong>
                          {getDateFormat(editor?.createdAt)}
                        </span>
                        <span>
                          <strong>Due By:</strong>&nbsp;
                          {get15DaysAheadDate(editor?.updatedAt, 15)}
                        </span>
                      </div>
                      <div className="timeList">
                        {!isSocietyConferencePaper(editor) && (
                          <span className="t-type text-transform-none">
                            {editor?.article[0]?.reviewType?.typeOfReview
                              .replace(/\bonly\b/g, "")
                              .replace(
                                /pre-publication peer review/gi,
                                "Pre-publication peer review",
                              )}
                          </span>
                        )}
                        <span className="t-type text-transform-none mr-0">
                          {editor?.article[0]?.submissionDetail?.journalType ===
                            "6454a6390d88e62fa10503bf"
                            ? "Accepted for Peer Review"
                            : editor?.status}
                        </span>
                      </div>
                    </div>
                  )}
                  {peActiveTab === "sendForReview" && (
                    <div className="contentListHead">
                      <div className="timeList">
                        <span>
                          <strong>Sent On:&nbsp;</strong>
                          {getDateFormat(editor?.createdAt)}
                        </span>
                      </div>
                      <div className="timeList">
                        {!isSocietyConferencePaper(editor) && (
                          <span className="t-type text-transform-none">
                            {editor?.article[0]?.reviewType?.typeOfReview
                              .replace(/\bonly\b/g, "")
                              .replace(
                                /pre-publication peer review/gi,
                                "Pre-publication peer review",
                              )}
                          </span>
                        )}
                        <span className="t-type text-transform-none mr-0">
                          {editor?.article[0]?.submissionDetail?.journalType ===
                            "6454a6390d88e62fa10503bf"
                            ? "Peer review in-process"
                            : editor?.status}
                        </span>
                      </div>
                    </div>
                  )}
                  {peActiveTab === "peerReview" && (
                    <div className="contentListHead">
                      {(() => {
                        const peerReviewOutcome = getPeerReviewOutcome(editor);

                        return (
                          <>
                            <div className="timeList">
                              <span>
                                <strong>Review Received:&nbsp;</strong>
                                {getDateFormat(editor?.createdAt)}
                              </span>
                              <span>
                                <strong>Peer Reviewer:&nbsp;</strong>
                                {editor?.prData?.[0]
                                  ? [
                                    editor?.prData?.[0]?.title || "",
                                    editor?.prData?.[0]?.fullName || "",
                                  ]
                                    .filter(
                                      (item) =>
                                        item.trim() !== "" &&
                                        item.trim().toLowerCase() !==
                                        "undefined",
                                    )
                                    .join(" ")
                                  : ""}
                              </span>
                            </div>
                            <div className="timeList d-flex flex-column align-items-start" style={{ gap: '4px' }}>
                              {peerReviewOutcome ? (
                                <div
                                  className="t-type text-transform-none mr-0"
                                  style={{
                                    ...peerReviewOutcome.style,
                                    borderRight: 'none',
                                    paddingRight: 0,
                                    marginRight: 0
                                  }}
                                >
                                  Result: {peerReviewOutcome.label}
                                </div>
                              ) : null}
                              {editor?.peStatus === "sentForRevision" && (
                                <div className="t-type text-transform-none mr-0" style={{ color: "#167092", fontWeight: 700, fontSize: "18px", marginTop: "20px" }}>
                                  Action: SENT FOR SECOND REVISION
                                </div>
                              )}
                            </div>
                          </>
                        );
                      })()}
                    </div>
                  )}
                  {(peActiveTab === "approved" || peActiveTab === "published") && (
                    <div className="contentListHead">
                      <div className="timeList">
                        <span>
                          <strong>Review Received:&nbsp;</strong>
                          {getDateFormat(editor?.createdAt)}
                        </span>
                        <span>
                          <strong>Approved On:&nbsp;</strong>
                          {getDateFormat(editor?.updatedAt)}
                        </span>
                        <span>
                          <strong>Published On:&nbsp;</strong>
                          {getDateFormat(editor?.updatedAt)}
                        </span>
                      </div>
                      <div className="timeList">
                        {!isSocietyConferencePaper(editor) && (
                          <span className="t-type text-transform-none">
                            {editor?.article[0]?.reviewType?.typeOfReview
                              .replace(/\bonly\b/g, "")
                              .replace(
                                /pre-publication peer review/gi,
                                "Pre-publication Peer Review",
                              )}
                          </span>
                        )}
                        <span className="t-type text-transform-none mr-0" style={{ color: "#1f8f57", fontWeight: "700" }}>
                          {editor?.article[0]?.submissionDetail?.journalType ===
                            "6454a6390d88e62fa10503bf"
                            ? "Article Published"
                            : editor?.status}
                        </span>
                      </div>
                    </div>
                  )}
                  {peActiveTab === "sentForRevision" && (
                    <div className="contentListHead">
                      <div className="timeList">
                        <span>
                          <strong>Review Received:&nbsp;</strong>
                          {getDateFormat(editor?.createdAt)}
                        </span>
                        <span>
                          <strong>Sent for Revision:&nbsp;</strong>
                          {getDateFormat(editor?.updatedAt)}
                        </span>
                      </div>
                      <div className="timeList">
                        {!isSocietyConferencePaper(editor) && (
                          <span className="t-type text-transform-none">
                            {editor?.article[0]?.reviewType?.typeOfReview
                              .replace(/\bonly\b/g, "")
                              .replace(
                                /pre-publication peer review/gi,
                                "Pre-publication peer review",
                              )}
                          </span>
                        )}
                        <span className="t-type text-transform-none mr-0">
                          {editor?.article[0]?.submissionDetail?.journalType ===
                            "6454a6390d88e62fa10503bf"
                            ? "Society Editor Assigned"
                            : editor?.status}
                        </span>
                      </div>
                    </div>
                  )}
                  {peActiveTab === "rejected" && (
                    <div className="contentListHead">
                      <div className="timeList">
                        <span>
                          <strong>Review Received:&nbsp;</strong>
                          {getDateFormat(editor?.createdAt)}
                        </span>
                        <span>
                          <strong>Rejected On:&nbsp;</strong>
                          {getDateFormat(editor?.updatedAt)}
                        </span>
                      </div>
                      <div className="timeList">
                        <span className="t-type text-transform-none mr-0">
                          {editor?.article[0]?.submissionDetail?.journalType ===
                            "6454a6390d88e62fa10503bf"
                            ? "Article Rejected"
                            : editor?.status}
                        </span>
                      </div>
                    </div>
                  )}

                  {peActiveTab === "notAccepted" && (
                    <div className="contentListHead">
                      <div className="timeList">
                        <span>
                          <strong>Review Received:&nbsp;</strong>
                          {getDateFormat(editor?.createdAt)}
                        </span>
                        <span>
                          <strong>Not Accepted On:&nbsp;</strong>
                          {getDateFormat(editor?.updatedAt)}
                        </span>
                      </div>
                      <div className="timeList">
                        {!isSocietyConferencePaper(editor) && (
                          <span className="t-type text-transform-none">
                            {editor?.article[0]?.reviewType?.typeOfReview
                              .replace(/\bonly\b/g, "")
                              .replace(
                                /pre-publication peer review/gi,
                                "Pre-publication Peer Review",
                              )}
                          </span>
                        )}
                        <span className="t-type text-transform-none mr-0">
                          {editor?.article[0]?.submissionDetail?.journalType ===
                            "6454a6390d88e62fa10503bf"
                            ? "Rejected (Out of Scope)"
                            : editor?.status}
                        </span>
                      </div>
                    </div>
                  )}
                  <div className="contentListMidd">
                    {peActiveTab === "draft" ? (
                      <h2
                        onClick={() => {
                          getReviewArticle(editor?.articleId);
                        }}
                      >
                        {editor?.article[0]?.title || "(No Title)"}
                        {showRedDot && (
                          <span
                            style={{
                              display: "inline-block",
                              width: "10px",
                              height: "10px",
                              backgroundColor: "red",
                              borderRadius: "50%",
                              marginLeft: "8px",
                              verticalAlign: "middle",
                            }}
                            title="Author chose to pay APC myself"
                          ></span>
                        )}
                      </h2>
                    ) : (
                      <h2>
                        <Link
                          to={{
                            pathname: `/dashboard/article/${editor?.articleId}/review-article`,
                          }}
                          state={{
                            _id: editor?.articleId,
                            particularId: editor?._id,
                            typeOfReview:
                              editor?.article?.[0]?.reviewType?.typeOfReview,
                            status: peActiveTab,
                            sendForRevision:
                              editor?.article?.[0]?.sendForRevision,
                          }}
                        >
                          {editor?.article[0]?.title || "(No Title)"}
                        </Link>
                        {showRedDot && (
                          <span
                            style={{
                              display: "inline-block",
                              width: "10px",
                              height: "10px",
                              backgroundColor: "red",
                              borderRadius: "50%",
                              marginLeft: "8px",
                              verticalAlign: "middle",
                            }}
                            title="Author chose to pay APC myself"
                          ></span>
                        )}
                      </h2>
                    )}

                    <div className="authorName">
                      <b>
                        {[
                          editor?.user?.[0]?.title || "",
                          editor?.user?.[0]?.fullName || "",
                        ]
                          .filter(
                            (item) =>
                              item.trim() !== "" &&
                              item.trim().toLowerCase() !== "undefined",
                          )
                          .join(" ")}
                        {editor?.article?.[0]?.authorDetails?.author?.length >
                          1 &&
                          editor?.article?.[0]?.authorDetails?.author?.some(
                            (auth) =>
                              auth?.fullName === editor?.user?.[0]?.fullName,
                          )
                          ? ", "
                          : ""}
                      </b>
                      {editor?.article?.[0]?.authorDetails?.author
                        ?.filter(
                          (auth) =>
                            auth?.fullName !== editor?.user?.[0]?.fullName,
                        )
                        .map((author, index) => {
                          return (
                            <b>
                              {(index ? ", " : "") +
                                [
                                  author?.title || "",
                                  author?.fullName || "",
                                ]
                                  .filter(
                                    (item) =>
                                      item.trim() !== "" &&
                                      item.trim().toLowerCase() !== "undefined",
                                  )
                                  .join(" ")}
                            </b>
                          );
                        })}
                    </div>
                    <div className="authorAff">
                      {getUserDetails(
                        editor?.user?.[0]?.affiliation?.affiliations?.[0],
                      )}
                    </div>

                    {(peActiveTab === "draft" || peActiveTab === "accepted") &&
                      contentWithoutSpecialChars()?.split(" ").length >
                      MAX_WORDS ? (
                      <p
                        dangerouslySetInnerHTML={{
                          __html:
                            contentWithoutSpecialChars()
                              ?.split(" ")
                              ?.slice(0, MAX_WORDS)
                              .join(" ") + "....",
                        }}
                      ></p>
                    ) : (
                      (peActiveTab === "draft" ||
                        peActiveTab === "accepted") && (
                        <p
                          dangerouslySetInnerHTML={{
                            __html: contentWithoutSpecialChars()
                              ?.split(" ")
                              ?.slice(0, MAX_WORDS)
                              .join(" "),
                          }}
                        ></p>
                      )
                    )}
                  </div>
                  {peActiveTab === "draft" ? (
                    <div className="footTag d-flex justify-content-start">
                      {editor?.article?.[0]?.submissionDetail?.journalName && (
                        <div className="t-tag-journalWrap">
                          <span className="t-tag t-tag-journal" title={editor?.article[0]?.submissionDetail?.journalName}>
                            {editor?.article[0]?.submissionDetail?.journalName}
                          </span>
                        </div>
                      )}
                      {editor?.subjectDetail[0]?.subjectName && (
                        <span className="t-tag">
                          {editor?.subjectDetail[0]?.subjectName}
                        </span>
                      )}
                      {editor?.specializations[0]?.specialization && (
                        <span className="t-tag ">
                          {editor?.specializations[0]?.specialization}
                        </span>
                      )}
                    </div>
                  ) : null}

                  <div
                    className={
                      peActiveTab === "draft"
                        ? "contentListFoot contentListTwo justify-content-end align-items-center"
                        : "contentListFoot contentListTwo align-items-center"
                    }
                  >
                    {peActiveTab !== "draft" ? (
                      <div className="footTag d-flex justify-content-start align-items-center">
                        {editor?.article?.[0]?.submissionDetail?.journalName && (
                          <div className="t-tag-journalWrap">
                            <span className="t-tag t-tag-journal" title={editor?.article[0]?.submissionDetail?.journalName}>
                              {editor?.article[0]?.submissionDetail?.journalName}
                            </span>
                          </div>
                        )}
                        {editor?.subjectDetail[0]?.subjectName && (
                          <span className="t-tag">
                            {editor?.subjectDetail[0]?.subjectName}
                          </span>
                        )}
                        {editor?.specializations[0]?.specialization && (
                          <span className="t-tag ">
                            {editor?.specializations[0]?.specialization}
                          </span>
                        )}
                      </div>
                    ) : null}

                    <div className="footAction">
                      {peActiveTab === "draft" ? (
                        <>
                          <Link
                            to="#"
                            className="button-link"
                            onClick={(e) => {
                              getReviewArticle(editor?.articleId);
                            }}
                          >
                            Take me to the article details
                          </Link>
                          {editor?.status === "First Revision" && (
                            <Link
                              to={{
                                pathname: `/dashboard/article/${editor?._id}/review-article`,
                              }}
                              state={{
                                _id: editor?.articleId,
                                particularId: editor?._id,
                                createdAt: editor?.createdAt,
                                updatedAt: editor?.updatedAt,
                                peData: editor?.peData,
                                typeOfReview:
                                  editor?.article?.[0]?.reviewType
                                    ?.typeOfReview,
                                status: peActiveTab,
                                articleStatus: "First Revision",
                                sendForRevision:
                                  editor?.article?.[0]?.sendForRevision,
                              }}
                              className="button button-primary"
                            >
                              Review Article
                            </Link>
                          )}
                          {editor?.status === "First Revision" &&
                            editor?.prReview && (
                              <Link
                                to={{
                                  pathname: `/dashboard/article/${editor?._id}/view-report`,
                                }}
                                state={{
                                  _id: editor?._id,
                                  rejectionArticleId: editor?.articleId,
                                  title: editor?.article?.[0]?.title,
                                  createdAt: editor?.createdAt,
                                  updatedAt: editor?.updatedAt,
                                  prData: editor?.peData,
                                  status: peActiveTab,
                                  userType: "Publishing Editor",
                                  sendForRevision:
                                    editor?.article?.[0]?.sendForRevision,
                                }}
                                className="button button-primary"
                              >
                                VIEW REPORT
                              </Link>
                            )}
                          <Link
                            to="#"
                            className="button-link-gray"
                            onClick={(e) => {
                              e.preventDefault();
                              setShowConfirmation(true);
                              setArticleId(editor?._id);
                            }}
                          >
                            Reject for editorial Assessment
                          </Link>
                          <Link
                            to="#"
                            className="button button-primary"
                            onClick={() => {
                              setArticleId(editor?._id);
                              setShowAcceptConfirmation(true);
                            }}
                          >
                            Accept for editorial Assessment
                          </Link>
                        </>
                      ) : peActiveTab === "peerReview" ||
                        (peActiveTab === "secondReview" && editor?.prReview) ? (
                        <>
                          <Link
                            to={{
                              pathname: `/dashboard/article/${editor?._id}/review-article`,
                            }}
                            state={{
                              _id: editor?.articleId,
                              particularId: editor?._id,
                              createdAt: editor?.createdAt,
                              updatedAt: editor?.updatedAt,
                              peData: editor?.peData,
                              typeOfReview:
                                editor?.article?.[0]?.reviewType?.typeOfReview,
                              status: peActiveTab,
                              sendForRevision:
                                editor?.article?.[0]?.sendForRevision,
                            }}
                            className="button button-primary"
                            style={{ whiteSpace: "nowrap" }}
                          >
                            VIEW ARTICLE
                          </Link>
                          <Link
                            to={{
                              pathname: `/dashboard/article/${editor?._id}/view-report`,
                            }}
                            state={{
                              _id: editor?._id,
                              rejectionArticleId: editor?.articleId,
                              title: editor?.article?.[0]?.title,
                              createdAt: editor?.createdAt,
                              updatedAt: editor?.updatedAt,
                              prData: editor?.prData,
                              status: peActiveTab,
                              userType: "Publishing Editor",
                              sendForRevision:
                                editor?.article?.[0]?.sendForRevision,
                            }}
                            className="button button-primary"
                            style={{ whiteSpace: "nowrap" }}
                          >
                            VIEW REPORT
                          </Link>
                          {(editor?.article?.[0]?.submissionDetail?.journalName?.trim()?.toLowerCase() !== "minorities in world politics" &&
                            (!window.location.pathname.includes('/dashboard/society-editor') ||
                              (((editor?.article?.[0]?.submissionDetail?.journalName?.trim()?.toLowerCase() === "community learning and social transformation") ||
                                (editor?.article?.[0]?.submissionDetail?.journalName?.trim()?.toLowerCase() === "applied and basic obesity, diabetes and endocrinology") ||
                                (editor?.article?.[0]?.submissionDetail?.journalName?.trim()?.toLowerCase() === "applied and basic obesity, diabetes and endocrinology journal") ||
                                (editor?.article?.[0]?.submissionDetail?.journalName?.trim()?.toLowerCase()?.includes("applied and basic obesity, diabetes and endocrinology"))) &&
                                (editor?.article?.[0]?.submissionDetail?.journalType === "6454a6390d88e62fa10503bf" ||
                                  editor?.article?.[0]?.submissionDetail?.journalType?._id === "6454a6390d88e62fa10503bf")))) && (
                              <button
                                className="button button-primary ms-3 view-invoice-btn"
                                style={{ color: "#167092", backgroundColor: "#ffffff", borderBottom: "3px solid #167092", whiteSpace: "nowrap" }}
                                onClick={() => {
                                  setPaymentArticleId(editor?._id);
                                  setSelectedArticle(editor);
                                  setUpiScreenshotUrl("");
                                  setUpiTransactionId("");
                                  setIsGatewayPaymentSuccessful(false);
                                  setShowPaymentModal(true);
                                }}
                              >
                                APPROVE TO PUBLISH
                              </button>
                            )}
                        </>
                      ) : peActiveTab === "sentForRevision" ? (
                        <Link
                          to="#"
                          className="button button-primary"
                          onClick={() => {
                            setShowNotAccepted(true);
                            setArticleId(editor?._id);
                            setRejectionArticleId(editor?.articleId);
                            setReasonHandle(editor?.peSentForRevisionReason);
                            setReasonComments(
                              editor?.peSentForRevisionReasonAdditionalComment,
                            );
                          }}
                        >
                          VIEW REASON
                        </Link>
                      ) : peActiveTab === "accepted" ? (
                        <>
                          {/* <Link
                            to={{
                              pathname: `/dashboard/article/${editor?._id}/review-article`,
                            }}
                            state={{
                              _id: editor?.articleId,
                              particularId: editor?._id,
                              createdAt: editor?.createdAt,
                              updatedAt: editor?.updatedAt,
                              peData: editor?.peData,
                              typeOfReview:
                                editor?.article?.[0]?.reviewType?.typeOfReview,
                              status: peActiveTab,
                              sendForRevision: editor?.article?.[0]?.sendForRevision,
                            }}
                            className="button button-primary"
                          >
                            Appoint PR
                          </Link> */}
                          {editor?.article[0]?.reviewType?.typeOfReview ===
                            "only post-publication open review" ? null : (
                            <div className="customDrop sideDrop dw-auto">
                              <Dropdown>
                                <Dropdown.Toggle
                                  className="button button-primary w-100"
                                  variant="success"
                                >
                                  Appoint PR
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                  <Dropdown.Item
                                    as={Link}
                                    to="/dashboard/society-editor/pr-listing"
                                    state={{
                                      _id: editor?.articleId,
                                      particularId: editor?._id,
                                      createdAt: editor?.createdAt,
                                      updatedAt: editor?.updatedAt,
                                      peData: editor?.peData,
                                      typeOfReview:
                                        editor?.article?.[0]?.reviewType
                                          ?.typeOfReview,
                                      status: peActiveTab,
                                      sendForRevision:
                                        editor?.article?.[0]?.sendForRevision,
                                    }}
                                    className="dropdown-item m-0"
                                  >
                                    Manual
                                  </Dropdown.Item>
                                  <Dropdown.Item
                                    onClick={() => {
                                      const edJournalName = editor?.article?.[0]?.submissionDetail?.journalName?.trim()?.toLowerCase();
                                      const isMWP = (edJournalName === "community learning and social transformation" ||
                                        edJournalName === "applied and basic obesity, diabetes and endocrinology" ||
                                        edJournalName === "applied and basic obesity, diabetes and endocrinology journal" ||
                                        edJournalName?.includes("applied and basic obesity, diabetes and endocrinology")) &&
                                        (editor?.article?.[0]?.submissionDetail?.journalType === "6454a6390d88e62fa10503bf" ||
                                          editor?.article?.[0]?.submissionDetail?.journalType?._id === "6454a6390d88e62fa10503bf");
                                      if (isMWP) {
                                        setPaymentArticleId(editor?._id);
                                        setSelectedArticle(editor);
                                        setUpiScreenshotUrl("");
                                        setUpiTransactionId("");
                                        setIsGatewayPaymentSuccessful(false);
                                        setShowPaymentModal(true);
                                      } else {
                                        handleAcceptRejectArticle(editor?._id, "published");
                                      }
                                    }}
                                    className="dropdown-item m-0"
                                  >
                                    Offline Peer Review
                                  </Dropdown.Item>
                                  <Dropdown.Item
                                    // onClick={handleAutomaticAppoint}
                                    className="dropdown-item m-0"
                                    style={
                                      window.location.pathname.includes('/dashboard/society-editor')
                                        ? { cursor: "not-allowed", pointerEvents: "none", backgroundColor: "#ffffff", color: "#e0e0e0" }
                                        : { backgroundColor: "#ffffff" }
                                    }
                                  >
                                    Automatic
                                  </Dropdown.Item>
                                </Dropdown.Menu>
                              </Dropdown>
                            </div>
                          )}
                          <Link
                            to={{
                              pathname: `/dashboard/society-editor/${editor?.articleId}/edit-article`,
                            }}
                            state={{ from: "society-editor", fromTab: peActiveTab }}
                            className="button button-primary"
                          >
                            Edit Article
                          </Link>
                          <Link
                            to={{
                              pathname: `/dashboard/article/${editor?._id}/review-article`,
                            }}
                            state={{
                              _id: editor?.articleId,
                              particularId: editor?._id,
                              createdAt: editor?.createdAt,
                              updatedAt: editor?.updatedAt,
                              peData: editor?.peData,
                              typeOfReview:
                                editor?.article?.[0]?.reviewType?.typeOfReview,
                              status: peActiveTab,
                              sendForRevision:
                                editor?.article?.[0]?.sendForRevision,
                            }}
                            className="button button-primary"
                          >
                            View Article
                          </Link>
                          <Link
                            // to={{
                            //   pathname: `/dashboard/article/${editor?._id}/review-article`,
                            // }}
                            // state={{
                            //   _id: editor?.articleId,
                            //   particularId: editor?._id,
                            //   createdAt: editor?.createdAt,
                            //   updatedAt: editor?.updatedAt,
                            //   peData: editor?.peData,
                            //   typeOfReview:
                            //     editor?.article?.[0]?.reviewType?.typeOfReview,
                            //   status: peActiveTab,
                            //   sendForRevision: editor?.article?.[0]?.sendForRevision,
                            // }}
                            onClick={() =>
                              handledownloadWordArticle(editor?.articleId)
                            }
                            className="button button-primary ms-0"
                          >
                            Download Article
                          </Link>
                        </>
                      ) : (peActiveTab === "approved" || peActiveTab === "published") ? (
                        <>
                          <Link
                            to={{
                              pathname: `/society-journal/${editor?.subjectDetail?.[0]?.subjectName
                                ?.toLowerCase()
                                .replace(/\s+/g, "-")}/article/${editor?.article?.[0]?.slug}`,
                            }}
                            className="button button-primary"
                          >
                            VIEW PUBLISHED ARTICLE
                          </Link>
                          {editor?.prReview ? (
                            <Link
                              to={{
                                pathname: `/dashboard/article/${editor?._id}/view-report`,
                              }}
                              state={{
                                _id: editor?._id,
                                rejectionArticleId: editor?.articleId,
                                title: editor?.article?.[0]?.title,
                                status: peActiveTab,
                                createdAt: editor?.createdAt,
                                updatedAt: editor?.updatedAt,
                                reasonHandle: editor?.peRejectedReason,
                                userType: "Publishing Editor",
                              }}
                              className="button button-primary"
                            >
                              PEER REVIEW REPORT
                            </Link>
                          ) : null}
                        </>
                      ) : peActiveTab === "rejected" ? (
                        <>
                          <Link
                            to={{
                              pathname: `/dashboard/article/${editor?._id}/review-article`,
                            }}
                            state={{
                              _id: editor?.articleId,
                              particularId: editor?._id,
                              createdAt: editor?.createdAt,
                              updatedAt: editor?.updatedAt,
                              peData: editor?.peData,
                              typeOfReview:
                                editor?.article?.[0]?.reviewType?.typeOfReview,
                              status: peActiveTab,
                              sendForRevision:
                                editor?.article?.[0]?.sendForRevision,
                            }}
                            className="button button-primary me-3"
                          >
                            VIEW ARTICLE
                          </Link>
                          <Link
                            to="#"
                            className="button button-primary"
                            onClick={() => {
                              setShowNotAccepted(true);
                              setArticleId(editor?._id);
                              setRejectionArticleId(editor?.articleId);
                              setReasonHandle(editor?.peRejectedReason);
                              setReasonComments(
                                editor?.peRejectedReasonAdditionalComment,
                              );
                            }}
                          >
                            VIEW REASON
                          </Link>
                        </>
                      ) : peActiveTab === "notAccepted" ? (
                        <Link
                          to="#"
                          className="button button-primary"
                          onClick={() => {
                            handleNotAcceptedReason(editor?.articleId);
                          }}
                        >
                          VIEW REASON
                        </Link>
                      ) : peActiveTab === "sendForReview" ? (
                        <>
                          <Link
                            to={{
                              pathname:
                                "/dashboard/society-editor/pr-appointment-history",
                            }}
                            state={"accepted"}
                            className="button button-primary"
                          >
                            Appointment History
                          </Link>
                          <Link
                            to={{
                              pathname: `/dashboard/article/${editor?._id}/review-article`,
                            }}
                            state={{
                              _id: editor?.articleId,
                              particularId: editor?._id,
                              createdAt: editor?.createdAt,
                              updatedAt: editor?.updatedAt,
                              peData: editor?.peData,
                              typeOfReview:
                                editor?.article?.[0]?.reviewType?.typeOfReview,
                              status: peActiveTab,
                              sendForRevision:
                                editor?.article?.[0]?.sendForRevision,
                            }}
                            className="button button-primary"
                          >
                            View Article
                          </Link>
                        </>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <div className="tabContentWrap">
            <div className="notArticle">
              <figure>
                <img src={notyet} alt="No Article" />
              </figure>
              {peActiveTab === "draft" ? (
                <div className="notArticleDraft">
                  <h2>No articles have arrived yet!</h2>
                  <p>
                    Articles requesting Editorial Assessment will feature here
                    {/* <span>
                      In the meantime, feel free to enjoy this moment by checking out our <u><b>playlists</b></u>. The next great adventure in scholarly exploration awaits...
                    </span> */}
                  </p>
                </div>
              ) : peActiveTab === "accepted" ? (
                <div className="notArticleAccepted">
                  <h2>No accepted manuscripts yet!</h2>
                  <p>
                    You help showcase ground-breaking research and ideas
                    {/* <span>
                      We appreciate the significance of your role in this journey. We aim to streamline your workflow and make the assessment process a breeze.
                    </span> */}
                  </p>
                </div>
              ) : peActiveTab === "sendForReview" ? (
                <div className="notArticleSendFor">
                  <h2>No research articles sent for peer review yet!</h2>
                  <p>
                    No shuffling through piles of paperwork or emails.
                    {/* <span>
                      Everything you need is just a click away! Thank you for being a part of our vibrant publishing community. Appreciate it...
                    </span> */}
                  </p>
                </div>
              ) : peActiveTab === "peerReview" ? (
                <div className="notArticlePeer">
                  <h2>Awaiting Peer Reviewed Articles</h2>
                  <p>
                    Peer Review reports for your review will land here
                    {/* <span>
                      All assessment reports in one place will allow you to make well-informed decisions about the research articles under your care.
                    </span> */}
                  </p>
                </div>
              ) : (peActiveTab === "approved" || peActiveTab === "published") ? (
                <div className="notArticleApproved">
                  <h2>{peActiveTab === "published" ? "No published articles yet!" : "No articles have met your approval yet!"}</h2>
                  <p>
                    {peActiveTab === "published" ? "All the published research articles shine bright here" : "All the brilliant research articles shine bright here"}
                    {/* <span>
                      By accepting these exceptional articles, you are opening doors to a world of knowledge and for new discoveries to flourish...
                    </span> */}
                  </p>
                </div>
              ) : peActiveTab === "sentForRevision" ? (
                <div className="notArticleSentRevision">
                  <h2>No articles sent for revision yet!</h2>
                  <p>
                    Provide valuable feedback that enhances author’s work
                    {/* <span>
                      Your feedback is a potent catalyst, fostering constructive criticism and intellectual growth. It's a win-win situation for everyone!
                    </span> */}
                  </p>
                </div>
              ) : peActiveTab === "rejected" ? (
                <div className="notArticleRejected">
                  <h2>No rejected articles here!</h2>
                  <p>
                    Articles that did not get accepted for publishing will show
                    here
                    {/* <span>
                      In scientific terms, this stage is the Schrödinger's cat, where the articles exist in a superposition, neither accepted nor rejected until they land here...
                    </span> */}
                  </p>
                </div>
              ) : peActiveTab === "notAccepted" ? (
                <div className="notArticleNot">
                  <h2>We respect Your reasons!</h2>
                  <p>
                    Articles you could not accept for assessment will show here
                    {/* <span>
                      We hope you will soon resume the reviewing process, contributing to the collective advancement of knowledge and scientific literature...
                    </span> */}
                  </p>
                </div>
              ) : null}
            </div>
          </div>
        )}
        {peActiveTab === "draft" && totalNoOfRecords > 1 ? (
          <div className="btnWrap mb-5 mt-4 text-center">
            {hasMoreRecords ? (
              <Link
                to={{ pathname: "/publishing-editor/requests" }}
                state={"draft"}
                className="button-border"
                onClick={(e) => window.scrollTo({ top: 0, behavior: "smooth" })}
              >
                View All Drafts
              </Link>
            ) : (
              <button
                type="button"
                className="button-border"
                disabled
                style={{ opacity: 0.5, cursor: "not-allowed" }}
              >
                View All Drafts
              </button>
            )}
          </div>
        ) : peActiveTab === "accepted" && totalNoOfRecords > 1 ? (
          <div className="btnWrap mb-5 mt-4 text-center">
            {hasMoreRecords ? (
              <Link
                to={{ pathname: "/publishing-editor/accepted" }}
                state={"accepted"}
                className="button-border"
                onClick={(e) => window.scrollTo({ top: 0, behavior: "smooth" })}
              >
                View All Accepted
              </Link>
            ) : (
              <button
                type="button"
                className="button-border"
                disabled
                style={{ opacity: 0.5, cursor: "not-allowed" }}
              >
                View All Accepted
              </button>
            )}
          </div>
        ) : peActiveTab === "sendForReview" && totalNoOfRecords > 1 ? (
          <div className="btnWrap mb-5 mt-4 text-center">
            {hasMoreRecords ? (
              <Link
                to={{ pathname: "/publishing-editor/review" }}
                state={"sendForReview"}
                className="button-border"
                onClick={(e) => window.scrollTo({ top: 0, behavior: "smooth" })}
              >
                View All Sent for Review
              </Link>
            ) : (
              <button
                type="button"
                className="button-border"
                disabled
                style={{ opacity: 0.5, cursor: "not-allowed" }}
              >
                View All Sent for Review
              </button>
            )}
          </div>
        ) : peActiveTab === "peerReview" && totalNoOfRecords > 1 ? (
          <div className="btnWrap mb-5 mt-4 text-center">
            {hasMoreRecords ? (
              <Link
                to={{ pathname: "/publishing-editor/peerReview" }}
                state={"peerReview"}
                className="button-border"
                onClick={(e) => window.scrollTo({ top: 0, behavior: "smooth" })}
              >
                View All Peer Review
              </Link>
            ) : (
              <button
                type="button"
                className="button-border"
                disabled
                style={{ opacity: 0.5, cursor: "not-allowed" }}
              >
                View All Peer Review
              </button>
            )}
          </div>
        ) : (peActiveTab === "approved" || peActiveTab === "published") && totalNoOfRecords > 1 ? (
          <div className="btnWrap mb-5 mt-4 text-center">
            {hasMoreRecords ? (
              <Link
                to={{ pathname: peActiveTab === "published" ? "/publishing-editor/published" : "/publishing-editor/approved" }}
                state={peActiveTab}
                className="button-border"
                onClick={(e) => window.scrollTo({ top: 0, behavior: "smooth" })}
              >
                {peActiveTab === "published" ? "View All Published" : "View All Approved"}
              </Link>
            ) : (
              <button
                type="button"
                className="button-border"
                disabled
                style={{ opacity: 0.5, cursor: "not-allowed" }}
              >
                {peActiveTab === "published" ? "View All Published" : "View All Approved"}
              </button>
            )}
          </div>
        ) : peActiveTab === "sentForRevision" && totalNoOfRecords > 1 ? (
          <div className="btnWrap mb-5 mt-4 text-center">
            {hasMoreRecords ? (
              <Link
                to={{ pathname: "/publishing-editor/revision" }}
                state={"sentForRevision"}
                className="button-border"
                onClick={(e) => window.scrollTo({ top: 0, behavior: "smooth" })}
              >
                View All Sent for Revision
              </Link>
            ) : (
              <button
                type="button"
                className="button-border"
                disabled
                style={{ opacity: 0.5, cursor: "not-allowed" }}
              >
                View All Sent for Revision
              </button>
            )}
          </div>
        ) : peActiveTab === "rejected" && totalNoOfRecords > 1 ? (
          <div className="btnWrap mb-5 mt-4 text-center">
            {hasMoreRecords ? (
              <Link
                to={{ pathname: "/publishing-editor/rejected" }}
                state={"rejected"}
                className="button-border"
                onClick={(e) => window.scrollTo({ top: 0, behavior: "smooth" })}
              >
                View All Rejected
              </Link>
            ) : (
              <button
                type="button"
                className="button-border"
                disabled
                style={{ opacity: 0.5, cursor: "not-allowed" }}
              >
                View All Rejected
              </button>
            )}
          </div>
        ) : peActiveTab === "notAccepted" && totalNoOfRecords > 1 ? (
          <div className="btnWrap mb-5 mt-4 text-center">
            {hasMoreRecords ? (
              <Link
                to={{ pathname: "/publishing-editor/notAccepted" }}
                state={"notAccepted"}
                className="button-border"
                onClick={(e) => window.scrollTo({ top: 0, behavior: "smooth" })}
              >
                View All Not Accepted
              </Link>
            ) : (
              <button
                type="button"
                className="button-border"
                disabled
                style={{ opacity: 0.5, cursor: "not-allowed" }}
              >
                View All Not Accepted
              </button>
            )}
          </div>
        ) : null}
      </div>

      <Modal
        dialogClassName="modal-dialog-centered"
        className="md-x authorModal"
        show={showBecomePE}
        id="congratsMobile"
        tabIndex={-1}
      >
        <Modal.Header className="modal-header">
          <div class="modal-icon"> </div>
          <h2 class="modal-title">BECOME A PUBLISHING EDITOR</h2>
          <button
            type="button"
            class="btn-close"
            ariaLabel="Close"
            onClick={() => setShowBecomePE(false)}
          ></button>
        </Modal.Header>

        <Modal.Body>
          <div className="aaforAss text-left pl-2 pr-2">
            <p>
              You are the chosen one! We think that your profile would be
              perfect for the role of Publishing Editor for the{" "}
              {appointRoleResponse?.[0]?.journal}.
            </p>
            <p className="mt-4">
              Would you like to accept the request to become a Publishing
              Editor?
            </p>
          </div>
        </Modal.Body>

        <Modal.Footer className="modal-footer">
          <span
            className="button-link-gray mr-3"
            onClick={() => {
              setShowBecomePE(false);
              setShowRejectRequest(true);
            }}
          >
            REJECT
          </span>
          <button
            className="button button-primary sm ml-3"
            onClick={() => {
              handleUpdateRoleForPE("Accepted");
            }}
          >
            ACCEPT
          </button>
        </Modal.Footer>
      </Modal>

      <Modal
        dialogClassName="modal-dialog-centered modal-md authorModal md-x"
        show={showAcceptRequest}
        id="congratsMobile"
        tabIndex={-1}
        className="md-x"
      >
        <Confetti width={"450px"} height={"300px"} numberOfPieces={100} />
        <Modal.Header className="modal-header">
          <div class="modal-icon">
            {" "}
            <img src={doneSvg} alt="#" />
          </div>
          <h2 class="modal-title">CONGRATULATIONS</h2>
          <button
            type="button"
            class="btn-close"
            ariaLabel="Close"
            onClick={() => setShowAcceptRequest(false)}
          ></button>
        </Modal.Header>

        <Modal.Body className="pt-0">
          <div className="aaforAss text-left pl-4 pr-2">
            <p>
              You are now a Publishing Editor for the{" "}
              {appointRoleResponse?.[0]?.journal}
            </p>
            <p className="mt-4">
              You can access the Publishing Editor dashboard from the Dashboard
              dropdown on the left panel.
            </p>
          </div>
        </Modal.Body>

        <Modal.Footer className="modal-footer">
          <button
            class="button button-primary"
            onClick={() => setShowAcceptRequest(false)}
          >
            Okay
          </button>
        </Modal.Footer>
      </Modal>

      <Modal
        dialogClassName="modal-dialog-centered modal-md authorModal md-x"
        show={showRejectRequest}
        id="congratsMobile"
        tabIndex={-1}
      >
        <Modal.Header className="modal-header">
          <h2 class="modal-title">REJECT REQUEST</h2>
          <button
            type="button"
            class="btn-close"
            ariaLabel="Close"
            onClick={() => setShowRejectRequest(false)}
          ></button>
        </Modal.Header>

        <Modal.Body className="pt-0">
          <div className="aaforAss">
            <p className="pl-2 ml-2">
              Are you sure you want to reject the <br /> request to become a
              Publishing Editor?
            </p>
          </div>
        </Modal.Body>

        <Modal.Footer className="modal-footer">
          <span
            className="btn-link-gray bold mr-3"
            onClick={() => {
              setShowRejectRequest(false);
              setShowRejectPublishingRole(true);
            }}
          >
            YES, REJECT
          </span>
          <button
            class="button button-primary"
            onClick={() => setShowRejectRequest(false)}
          >
            NO, DON'T REJECT
          </button>
        </Modal.Footer>
      </Modal>

      <Modal
        dialogClassName="modal-dialog-centered modal-md authorModal md-x"
        show={showRejectPublishingRole}
        id="congratsMobile"
        tabIndex={-1}
        className="md-x"
      >
        <Modal.Header className="modal-header">
          <h2 class="modal-title">Reject Publishing editor role</h2>
          <button
            type="button"
            class="btn-close"
            ariaLabel="Close"
            onClick={() => setShowRejectPublishingRole(false)}
          ></button>
        </Modal.Header>

        <Modal.Body className="pb-0">
          <div className="rejectModal">
            <div className="row">
              <div className="col-md-12">
                <div className="fieldWrap">
                  <label className="labelForm">
                    Please specify your reason{" "}
                    <i className="reason-optional"> (Optional)</i>
                  </label>

                  <textarea
                    className="inputField mt-0"
                    placeholder="Enter your response here..."
                    onChange={(e) => setReasonInput(e.target.value)}
                    value={reasonInput}
                  ></textarea>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer className="modal-footer">
          <button
            class="button button-primary"
            onClick={() => handleUpdateRoleForPE("Rejected")}
          >
            SUBMIT
          </button>
        </Modal.Footer>
      </Modal>

      <ConfirmationalModal
        setShowReject={setShowReject}
        showConfirmation={showConfirmation}
        setShowConfirmation={setShowConfirmation}
        title={"Confirmation"}
        body={`<div class="text-center allGoodText01"><p>Are you sure you want to reject this article for editorial assessment?</div></p>`}
        leftBtnTxt={"REJECT"}
        rightBtnTxt={"MY DASHBOARD"}
      />

      <Modal
        dialogClassName="modal-dialog-centered modal-md authorModal md-x"
        show={showAcceptConfirmation}
        id="congratsMobile"
        tabIndex={-1}
        className="md-x"
      >
        <Modal.Header className="modal-header">
          <h2 class="modal-title">Good to know</h2>
          <button
            type="button"
            class="btn-close"
            ariaLabel="Close"
            onClick={() => setShowAcceptConfirmation(false)}
          ></button>
        </Modal.Header>

        <Modal.Body className="pt-0">
          <div className="aaforAss text-center">
            <p className="allGoodText02">
              Are you sure you want to accept this article for editorial
              assessment?
            </p>
          </div>
        </Modal.Body>

        <Modal.Footer className="modal-footer">
          <span
            className="btn-link-active bold mr-3"
            onClick={() => setShowAcceptConfirmation(false)}
          >
            MY DASHBOARD
          </span>
          <button
            class="button button-primary"
            onClick={() => handleAcceptRejectArticle(articleId, "accepted")}
          >
            ACCEPT
          </button>
        </Modal.Footer>
      </Modal>
      <RejectModalSociety
        showReject={showReject}
        setShowReject={setShowReject}
        articleId={articleId}
        articleType={peData[0]?.article[0]?.reviewType?.typeOfReview}
        fetchPublishingEditor={fetchPublishingEditor}
        userId={id}
        setUpdateRequestList={setUpdateRequestList}
      />
      {/* <RejectModalSociety
        showReject={showSocietyReject}
        setShowReject={setShowSocietyReject}
        articleId={articleId}
        fetchPublishingEditor={fetchPublishingEditor}
        userId={id}
        setUpdateRequestList={setUpdateRequestList}
      /> */}
      <Modal
        dialogClassName="modal-dialog-centered modal-md authorModal md-x"
        show={showAccept}
        id="congratsMobile"
        tabIndex={-1}
        className="md-x"
      >
        {" "}
        <Confetti width={"450px"} height={"350px"} numberOfPieces={100} />
        <Modal.Header className="modal-header">
          <div class="modal-icon">
            {" "}
            <img src={doneSvg} alt="#" />
          </div>
          <h2 class="modal-title">Accepted for PEER REVIEW </h2>
          <button
            type="button"
            class="btn-close"
            ariaLabel="Close"
            onClick={() => setShowAccept(false)}
          ></button>
        </Modal.Header>
        <Modal.Body className="pt-0">
          <div className="acceptedArticle text-left">
            <p className="mb-2">
              The article has been accepted for the next stage of editorial
              review.
            </p>
            <p className="mb-2">
              It will now proceed for further evaluation, including peer review
              as applicable.
            </p>

            <p className="mb-2">
              You can track its progress in your dashboard.
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer className="modal-footer">
          <button
            class="button button-primary"
            onClick={() => {
              setShowAccept(false);
              if (getPEType && setPEActiveTab) {
                setPEActiveTab("accepted");
                getPEType("accepted");
              }
            }}
          >
            OKAY
          </button>
        </Modal.Footer>
      </Modal>
      <ReasonModal
        showNotAccepted={showNotAccepted}
        setShowNotAccepted={setShowNotAccepted}
        reasonHandle={reasonHandle}
        reasonComments={reasonComments}
        peActiveTab={peActiveTab}
        _id={articleId}
        rejectionArticleId={rejectionArticleId}
      />
      {peActiveTab === "draft" && (
        <ArticleDetailsModal
          showArticleDetails={showArticleDetails}
          setShowArticleDetails={setShowArticleDetails}
          articleData={articleData}
          currentData={currentData}
          userDetail={userDetail}
          status={"Publishing Editor"}
        />
      )}
      <Modal
        show={showPaymentModal}
        onHide={() => setShowPaymentModal(false)}
        dialogClassName="modal-dialog-centered"
        size="lg"
      >
        <Modal.Header className="modal-header payment-modal-header">
          <h2 className="modal-title">Final Article Processing Charge Required</h2>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={() => setShowPaymentModal(false)}
          ></button>
        </Modal.Header>
        <Modal.Body className="p-4 payment-modal-body">
          <p style={{ fontSize: "20px", fontweight: "500" }}><h5>Your article has been approved for publication.</h5></p>
          <p style={{ marginBottom: "20px" }}>
            To complete the final publication process, kindly pay the mandatory Article Processing Charge (APC) of: <strong>{isSocietyConferencePaper(selectedArticle) ? "INR 2999 (inclusive of 18% GST)" : "INR 6499 plus 18% GST"}</strong>
          </p>
          <div className="mb-4 d-flex justify-content-center">
            <button
              className="button button-primary view-invoice-btn"
              style={{ color: "#167092", backgroundColor: "#ffffff", borderBottom: "3px solid #167092" }}
              onClick={() => {
                window.open(`/manage-payment/${selectedArticle?.articleId}`, "_blank");
              }}
            >
              VIEW INVOICE
            </button>
          </div>
          <hr />
          <h5 style={{ marginTop: "20px" }}>Payment Method 1 — Payment Gateway</h5>
          <p style={{ paddingBottom: "15px", paddingTop: "20px" }}>
            If you prefer to pay using Debit Card, Credit Card, Net Banking, or International Payment methods, you may proceed through the secure Payment Gateway.
          </p>
          <div className="mb-4 d-flex justify-content-center">
            <button
              className="button-border button-border-hover-red"
              onClick={() => {
                if (paymentArticleId) {
                  const articleDocId = selectedArticle?.articleId || selectedArticle?.article?.[0]?._id;
                  paymentInitiation(articleDocId);
                }
              }}
            >
              Proceed to Payment Gateway
            </button>
          </div>
          <hr />
          <h5 style={{ marginTop: "20px", marginBottom: "10px" }}>Payment Method 2 — Direct UPI Payment</h5>
          <p style={{ paddingTop: "20px", paddingBottom: "20px" }}>
            Please make the payment using the following UPI ID:<br />
            <strong>9810846333.eazypay@icici</strong>
            <i
              className="fa fa-copy ms-2 cursor-pointer"
              style={{ cursor: "pointer", color: "#336d91" }}
              onClick={copyUpiToClipboard}
              title="Copy UPI ID"
            ></i>
          </p>
          <p style={{ paddingBottom: "10px" }}>
            After completing the payment, kindly upload the payment screenshot or enter the transaction reference number below for verification.
          </p>
          <div className="mb-3 d-flex flex-column align-items-center">
            <button
              className="button-border button-border-hover-red"
              onClick={() => hiddenFileInput.current?.click()}
            >
              {upiScreenshotUrl ? "Revise Payment Screenshot" : "Upload Payment Screenshot"}
            </button>
            <input
              type="file"
              hidden
              ref={hiddenFileInput}
              onChange={handleUploadScreenshot}
              accept="image/*"
            />
            {upiScreenshotUrl && (
              <div className="mt-2 d-flex flex-column align-items-center">
                <div className="text-success mb-2">
                  <i className="icon-check me-1"></i> Screenshot uploaded successfully
                </div>
                <div className="position-relative" style={{ display: "inline-block", width: "120px", height: "120px", border: "1px solid #ccc", borderRadius: "5px", padding: "5px", backgroundColor: "#f9f9f9" }}>
                  <img
                    src={upiScreenshotUrl}
                    alt="Payment Screenshot"
                    style={{ width: "100%", height: "100%", objectFit: "cover", cursor: "pointer" }}
                    onClick={() => window.open(upiScreenshotUrl, "_blank")}
                    title="Click to view full size"
                  />
                  <button
                    type="button"
                    style={{
                      position: "absolute",
                      top: "2px",
                      right: "2px",
                      width: "20px",
                      height: "20px",
                      padding: "0",
                      fontSize: "12px",
                      lineHeight: "1",
                      backgroundColor: "#ff4d4f",
                      color: "#fff",
                      border: "none",
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                      fontWeight: "bold",
                    }}
                    onClick={() => setUpiScreenshotUrl("")}
                    title="Remove image"
                  >
                    &times;
                  </button>
                </div>
              </div>
            )}
          </div>
          <p style={{ paddingTop: "20px", paddingBottom: "20px", textAlign: "center" }}>OR</p>
          <div className="mb-4 d-flex flex-column align-items-center">
            <label style={{ fontSize: "16px", fontWeight: "bold", paddingBottom: "10px", textAlign: "center" }}>Transaction Reference ID</label>
            <input
              type="text"
              className="form-control mt-1 text-center"
              style={{ maxWidth: "300px" }}
              placeholder="Type here..."
              value={upiTransactionId}
              onChange={(e) => setUpiTransactionId(e.target.value)}
            />
          </div>
          <p className="mandatory-blink-text">Please upload payment screenshot or reference id for confirmation. This is a mandatory step.</p>
          <hr />
          <h5>Note</h5>
          <p>
            The article will be published once the <b>UPI PAYMENT</b> is successfully verified by the publishing team. Thank you for publishing with Aakashganga Open.
          </p>
        </Modal.Body>
      </Modal>
      <Modal
        show={showCongratsModal}
        onHide={() => setShowCongratsModal(false)}
        dialogClassName="modal-dialog-centered"
        size="md"
      >
        <Modal.Header className="modal-header payment-modal-header d-flex flex-column align-items-center position-relative">
          <h2 className="modal-title w-100 text-center" style={{ margin: "30px 0 10px 0" }}>Congratulations!</h2>
          <button
            type="button"
            className="btn-close position-absolute"
            style={{ top: "20px", right: "20px" }}
            aria-label="Close"
            onClick={() => setShowCongratsModal(false)}
          ></button>
        </Modal.Header>
        <Modal.Body className="p-4 payment-modal-body text-center">
          <p style={{ fontSize: "18px", fontWeight: "500", marginBottom: "30px", color: "#000000" }}>
            Your payment is successful.
          </p>
          <div className="d-flex justify-content-center">
            <button
              className="button button-primary"
              onClick={() => {
                if (paymentArticleId) {
                  handleAcceptRejectArticle(paymentArticleId, "published");
                }
                setShowCongratsModal(false);
              }}
            >
              Publish Article
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default PEListing;
